import { Flex } from '@mantine/core';
import { useEffect, useState } from 'react';
import PageLoader from 'src/UI/loader/PageLoader';
import { MeetingsEmptyView } from 'src/meetings/components/MeetingsEmptyView';
import { useCalendarEvents } from 'src/meetings/hooks/useCalendarEvents';
import { useCalendars } from 'src/meetings/hooks/useCalendars';
import { TAB_NAME, UpcomingEventsPanel } from 'src/meetings/home/UpcomingEventsPanel';
import { EventDetailPanel } from 'src/meetings/home/EventDetailPanel';

export const MeetingsPage = () => {
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
  const { justConnected, calendars, isLoading: calendarsLoading } = useCalendars();
  const [tabName, setTabName] = useState<(typeof TAB_NAME)[keyof typeof TAB_NAME]>(TAB_NAME.CLIENT);

  const { events: upcomingEvents, refetch: refetchUpcoming } = useCalendarEvents({
    pastOrUpcoming: 'UPCOMING',
    clientMeetingsOnly: tabName === TAB_NAME.CLIENT,
  });
  const { refetch: refetchPast } = useCalendarEvents({
    pastOrUpcoming: 'PAST',
    clientMeetingsOnly: true,
  });

  const selectedEvent = upcomingEvents.find(e => e.id === selectedEventId);

  useEffect(() => {
    if (!justConnected) {
      return;
    }
    refetchUpcoming();
    refetchPast();
  }, [justConnected]);

  useEffect(() => {
    refetchUpcoming();
    refetchPast();
  }, [calendars]);

  if (calendarsLoading) {
    return <PageLoader />;
  }

  return (
    <>
      <MeetingsEmptyView calendars={calendars} isLoading={calendarsLoading} />

      {calendars.length > 0 && (
        <Flex h="calc(100vh - 72px)">
          <Flex direction="column" flex={4} bg="gray.1" style={{ overflowY: 'scroll' }}>
            <UpcomingEventsPanel
              tabName={tabName}
              onTabChange={setTabName}
              selectedEventId={selectedEventId}
              onEventSelect={setSelectedEventId}
              onRefetchNeeded={refetchUpcoming}
              tabNameConstants={TAB_NAME}
            />
          </Flex>
          <Flex direction="column" flex={6} bg="white" style={{ overflowY: 'scroll' }}>
            <EventDetailPanel
              selectedEvent={selectedEvent}
              onCloseEvent={() => setSelectedEventId(null)}
            />
          </Flex>
        </Flex>
      )}
    </>
  );
};
